export default "__VITE_ASSET__B_6SmpRM__"